import { Outlet, createFileRoute } from '@tanstack/react-router'
import { KioskLayout } from '@/widgets/layouts/kiosk-layout'

// Unauthenticated until kiosk authentication is decided (docs/open-questions.md Q6).
export const Route = createFileRoute('/kiosk')({
  component: () => (
    <KioskLayout>
      <Outlet />
    </KioskLayout>
  ),
})
